export default __webpack_public_path__ + "static/media/css.a5d241f4.png";